import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0334',
    ecrans: ['00-2'],
    params: ['id',
             '?asocleint']
});
